import script from "./RelatedOrganisation.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatedOrganisation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__